import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { observer } from 'mobx-react';
import { BaseCluster } from '../../../pages/questionClusterTypes';
import MultilineText from '../../MultilineText';

interface Props {
  cluster: BaseCluster,
  renderQuestions: () => JSX.Element
}

type LocalStyles = 'headerSection' | 'paper';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  headerSection: {
    textAlign: 'left',
    marginBottom: theme.spacing.unit * 2,
  },
  paper: {
    padding: theme.spacing.unit
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class Cluster extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props)
  }

  public render() {
    const {classes} = this.props;
    return (
      <Paper elevation={1} className={classes.paper}>
        <div className={classes.headerSection}>
          {
            this.props.cluster.title !== '' &&
            <Typography variant="h5">
              {this.props.cluster.title}
            </Typography>
          }
          {
            this.props.cluster.description !== '' &&
            <Typography variant='body1' key={'description'}>
              <MultilineText text={this.props.cluster.description}/>
            </Typography>
          }
        </div>
        {
          this.props.renderQuestions()
        }
      </Paper>
    )
  }
}

export default withStyles(localStyles)(Cluster);

